import { IconProps } from "@/src/sb/business-layer/types"

const ArrowTopRight = (props: IconProps) => (
  <svg
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox={`${props.minX ?? 0} ${props.minY ?? 0} ${
      props.width ?? props.size ?? 18
    } ${props.width ?? props.size ?? 18}`}
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1819 5.81767H6.87862L6.87862 6.56543L10.9012 6.56808L5.02247 12.4468L5.5528 12.9771L11.4315 7.09841L11.4342 11.121H12.1819V5.81767Z"
      fill="currentColor"
    />
  </svg>
)

export default ArrowTopRight
